// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Создайте файл \`DatePickerStyles.scss\` и добавьте в него стили */
.date-picker-input {
  width: 180px;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #d1d1d1;
  font-family: "Montserrat Regular", sans-serif;
  font-size: 14px;
}

.react-datepicker-wrapper {
  width: 33%;
  position: relative;
}

.react-datepicker__input-container input {
  width: 240px;
  border: 1px solid #d1d1d1;
  padding: 8px;
  border-radius: 8px;
  box-sizing: border-box;
}

.react-datepicker-popper {
  z-index: 9999;
  transform: none !important;
  top: 45px !important;
}

.react-datepicker {
  font-family: "Montserrat Regular", sans-serif;
  border-radius: 8px;
  border: 1px solid #d1d1d1;
}

.react-datepicker__header {
  background-color: #ffffff;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  margin-top: 10px;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  font-weight: 500;
  font-size: 16px;
  margin-top: 10px;
  color: #000000;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  font-weight: 500;
  font-size: 14px;
  color: #000000;
}

.react-datepicker__day--selected,
.react-datepicker__day--keyboard-selected {
  background-color: #c93297;
  color: #ffffff;
}

.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range {
  background-color: #d62f78;
  color: #000000;
}

.react-datepicker__day--today {
  font-weight: bold;
  background-color: #d291bc;
  color: #000000;
}

.react-datepicker__navigation--previous,
.react-datepicker__navigation--next {
  margin-bottom: 10px;
  top: 15px;
}

.react-datepicker__close-icon::after {
  background-color: transparent;
  font-size: 12px;
  color: #d291bc;
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/StatisticsPage/CustomDatePicker/DatePickerStyles.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,kEAAA;AAEA;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,6CAAA;EACA,eAAA;AACJ;;AAEE;EACE,UAAA;EACA,kBAAA;AACJ;;AAEE;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AACJ;;AAKE;EACE,aAAA;EACA,0BAAA;EACA,oBAAA;AAFJ;;AAKE;EACE,6CAAA;EACA,kBAAA;EACA,yBAAA;AAFJ;;AAKE;EACE,yBAAA;EACA,mBAAA;EACA,0BAAA;EACA,gBAAA;AAFJ;;AAKE;;;EAGE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAFJ;;AAKE;;;EAGE,gBAAA;EACA,eAAA;EACA,cAAA;AAFJ;;AAKE;;EAEE,yBAAA;EACA,cAAA;AAFJ;;AAKE;;EAEE,yBAAA;EACA,cAAA;AAFJ;;AAKE;EACE,iBAAA;EACA,yBAAA;EACA,cAAA;AAFJ;;AAKE;;EAEE,mBAAA;EACA,SAAA;AAFJ;;AAKE;EACE,6BAAA;EACA,eAAA;EACA,cAAA;AAFJ","sourcesContent":["/* Создайте файл `DatePickerStyles.scss` и добавьте в него стили */\n\n.date-picker-input {\n    width: 180px;\n    padding: 8px;\n    border-radius: 8px;\n    border: 1px solid #d1d1d1;\n    font-family: 'Montserrat Regular', sans-serif;\n    font-size: 14px;\n  }\n  \n  .react-datepicker-wrapper {\n    width: 33%;\n    position: relative;\n  }\n  \n  .react-datepicker__input-container input {\n    width: 240px;\n    border: 1px solid #d1d1d1;\n    padding: 8px;\n    border-radius: 8px;\n    box-sizing: border-box;\n  }\n  // .react-datepicker__month-container {\n\n  // }\n  \n  .react-datepicker-popper {\n    z-index: 9999;\n    transform: none !important;\n    top: 45px !important;\n  }\n  \n  .react-datepicker {\n    font-family: 'Montserrat Regular', sans-serif;\n    border-radius: 8px;\n    border: 1px solid #d1d1d1;\n  }\n  \n  .react-datepicker__header {\n    background-color: #ffffff;\n    border-bottom: none;\n    border-radius: 8px 8px 0 0;\n    margin-top: 10px;\n  }\n  \n  .react-datepicker__current-month,\n  .react-datepicker-time__header,\n  .react-datepicker-year-header {\n    font-weight: 500;\n    font-size: 16px;\n    margin-top: 10px;\n    color: #000000;\n  }\n  \n  .react-datepicker__day-name,\n  .react-datepicker__day,\n  .react-datepicker__time-name {\n    font-weight: 500;\n    font-size: 14px;\n    color: #000000;\n  }\n  \n  .react-datepicker__day--selected,\n  .react-datepicker__day--keyboard-selected {\n    background-color: #c93297;\n    color: #ffffff;\n  }\n  \n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__day--in-range {\n    background-color: #d62f78;\n    color: #000000;\n  }\n  \n  .react-datepicker__day--today {\n    font-weight: bold;\n    background-color: #d291bc;\n    color: #000000;\n  }\n  \n  .react-datepicker__navigation--previous,\n  .react-datepicker__navigation--next {\n    margin-bottom: 10px;\n    top: 15px;\n  }\n  \n  .react-datepicker__close-icon::after {\n    background-color: transparent;\n    font-size: 12px;\n    color: #d291bc;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"date-picker-input": `date-picker-input`,
	"react-datepicker-wrapper": `react-datepicker-wrapper`,
	"react-datepicker__input-container": `react-datepicker__input-container`,
	"react-datepicker-popper": `react-datepicker-popper`,
	"react-datepicker": `react-datepicker`,
	"react-datepicker__header": `react-datepicker__header`,
	"react-datepicker__current-month": `react-datepicker__current-month`,
	"react-datepicker-time__header": `react-datepicker-time__header`,
	"react-datepicker-year-header": `react-datepicker-year-header`,
	"react-datepicker__day-name": `react-datepicker__day-name`,
	"react-datepicker__day": `react-datepicker__day`,
	"react-datepicker__time-name": `react-datepicker__time-name`,
	"react-datepicker__day--selected": `react-datepicker__day--selected`,
	"react-datepicker__day--keyboard-selected": `react-datepicker__day--keyboard-selected`,
	"react-datepicker__day--in-selecting-range": `react-datepicker__day--in-selecting-range`,
	"react-datepicker__day--in-range": `react-datepicker__day--in-range`,
	"react-datepicker__day--today": `react-datepicker__day--today`,
	"react-datepicker__navigation--previous": `react-datepicker__navigation--previous`,
	"react-datepicker__navigation--next": `react-datepicker__navigation--next`,
	"react-datepicker__close-icon": `react-datepicker__close-icon`
};
export default ___CSS_LOADER_EXPORT___;
